import { useQuery } from '@tanstack/react-query';
import { http } from 'services/http';
import { FUTURE_PAYMENTS_STATISTICS_GET } from 'api/query-keys';
import type { TGetFuturePaymentsStatisticsRes } from 'api/swagger';

export const useGetFuturePaymentsStatistics = () => {
  return useQuery<TGetFuturePaymentsStatisticsRes>({
    queryKey: [FUTURE_PAYMENTS_STATISTICS_GET],
    queryFn: async () => {
      const { data } = await http.get<TGetFuturePaymentsStatisticsRes>('/v1/statistics/future-payments');
      return data;
    },
    retry: false,
    refetchOnWindowFocus: false,
  });
};
